var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.user)?_c('img',{staticClass:"w-10 h-10 rounded-full cursor-pointer",class:_vm.className,attrs:{"src":_vm.image,"alt":"avatar","title":_vm.user.pseudo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }